import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Typography, Grid, Avatar, IconButton, Tooltip,
} from '@material-ui/core';
import {
    Edit, InfoOutlined,
} from '@material-ui/icons';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiSyncAlert } from '@mdi/js';
import './ScheduleSelectionSummary.scss';
import ChipCompletedStep from '@commonClient2/components/ChipCompletedStep';
import { UPDATE_DRAFT_BID_PROFILE_OBJECTS } from '../../../store/bidProfileDraft';
import { UPDATE_BID_PROFILE_OBJECTS } from '../../../store/bidProfile';
import { BidProfileEditTab, ScheduleSource } from '../../../../Enums';

function ScheduleSelectionSummary() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfileDraft, bidProfile } = useSelector((state) => state);
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'form.scheduleSelection' });

    /**
     * @type {BiddingDraft.IBidProfileDraft | BidProfile.IBidProfile | undefined}
     */
    let profile;
    let isDraft = false;
    let handleEdit = () => { };
    let isReImportNeeded = false;
    if (bidProfileDraft.id !== '') {
        profile = bidProfileDraft;
        isReImportNeeded = profile.originalBidProfileInformation.scheduleSource === ScheduleSource.WorkplanManager
            && profile.originalScheduleTemplates.isReImportNeeded;
        isDraft = true;

        handleEdit = () => {
            dispatch({
                type: UPDATE_DRAFT_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: false,
                    },
                    scheduleTemplates: {
                        isExpanded: true,
                    },
                    employees: {
                        isExpanded: false,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    } else if (bidProfile.id !== '') {
        profile = bidProfile;
        isDraft = false;

        handleEdit = () => {
            dispatch({
                type: UPDATE_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: false,
                    },
                    scheduleTemplates: {
                        isExpanded: true,
                    },
                    employees: {
                        isExpanded: false,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    }

    // @ts-ignore
    if (profile === undefined) {
        return <></>;
    }

    const {
        bidProfileInformation,
        scheduleTemplates,
        originalScheduleTemplates,
        isCreationAllowed,
        isViewAllowed,
    } = profile;

    const headerText = bidProfileInformation.scheduleSource === ScheduleSource.WorkplanManager
        ? t('subHeaderWorkplan')
        : t('subHeaderCsv');

    return (
        <div className="summary-section">
            <div className="summary-section-header">
                <div className="summary-section-avatar-title-wrapper">
                    <Avatar className="bde-avatar">2</Avatar>
                    <Typography variant="h6">{headerText}</Typography>
                </div>
                <Grid
                    item
                    className="summary-section-indicator-container"
                >
                    {
                        isDraft
                            ? (
                                <div
                                    className="summary-completed-icon-wrapper"
                                >
                                    {
                                        isReImportNeeded ? (
                                            <Tooltip
                                                title="Schedule templates have changed"
                                                arrow
                                            >
                                                <MdiIcon
                                                    path={mdiSyncAlert}
                                                    size={1.5}
                                                    color="orange"
                                                />
                                            </Tooltip>
                                        ) : (originalScheduleTemplates.isCompleted && <ChipCompletedStep />)
                                    }
                                </div>
                            )
                            : null
                    }
                    {(isCreationAllowed || isViewAllowed) && (
                        <IconButton
                            color="primary"
                            className="summary-edit-button"
                            onClick={() => handleEdit()}
                            hidden
                        >
                            {(scheduleTemplates.isEditable && isCreationAllowed) ? <Edit /> : <InfoOutlined />}
                        </IconButton>
                    )}
                </Grid>
            </div>
            <div className="summary-section-content">
                {
                    bidProfileInformation.scheduleSource === ScheduleSource.WorkplanManager ? (
                        <>
                            {
                                originalScheduleTemplates.retrievedWorkplans?.workplans.map((x) => (
                                    <div
                                        key={x.workplanId}
                                    >
                                        <Typography
                                            variant="body1"
                                            display="inline"
                                        >
                                            {t('shiftlines')}
                                            {' '}
                                            {t('fromWorkplan')}
                                            {' '}
                                            {x.name}
                                            {' : '}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            display="inline"
                                            className="sss-value-container"
                                        >
                                            {x.scheduleTemplates.items.filter((i) => i.isSelected).length}
                                        </Typography>
                                    </div>
                                ))
                            }
                        </>
                    ) : (
                        <>
                            <Typography
                                variant="body1"
                                display="inline"
                            >
                                {t('shiftlines')}
                                {' : '}
                            </Typography>
                            <Typography
                                className="bi-summary-description sss-value-container"
                                variant="body2"
                                display="inline"
                            >
                                {originalScheduleTemplates.items.filter((x) => x.isSelected).length}
                            </Typography>
                        </>
                    )
                }
            </div>
        </div>
    );
}

export default ScheduleSelectionSummary;
